const subuserStatementsFR = {
    "view": {
        "table": {
            "title": "Liste des relevés de votre sous-utilisateur",
            "column": {
                "type": "Type",
                "year": "Année",
                "month": "Mois",
                "issue_year": "Année d'émission",
                "issue_month": "Mois d'émission",
                "description": "Description",
                "amount": "Montant",
                "status": "Statut",
                "details": "Détails",
                "overview": "Aperçu",
                "action": "Action"
            },
            "button": {
                "export_csv": "Exporter CSV",
                "download": "Télécharger"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "label": {
                "statusOpen": "Ouvert",
                "statusPaid": "Payé",
                "typeLicensing": "Licences",
                "typeRegular": "Régulier",
                "typeAudioMasteringServices": "Mastering Audio - Services",
                "typeVinylEarnings": "Revenus Vinyle",
                "typeOffset": "Compensation",
                "typeNotKnown": "Inconnu",
                "monthJanuary": "Janvier",
                "monthFebruary": "Février",
                "monthMarch": "Mars",
                "monthApril": "Avril",
                "monthMay": "Mai",
                "monthJune": "Juin",
                "monthJuly": "Juillet",
                "monthAugust": "Août",
                "monthSeptember": "Septembre",
                "monthOctober": "Octobre",
                "monthNovember": "Novembre",
                "monthDecember": "Décembre"
            },
            "dropdown": {
                "markAsPaid": "Marquer comme PAYÉ",
                "markAsOpen": "Marquer comme OUVERT",
                "action": "Action"
            },
            "message": {
                "statementUnavailable": "Tous les relevés émis avant janvier 2023 sont disponibles en pièces jointes ZIP dans votre e-mail."
            }
        },
        "message": {
            "successMarkedOpen": "Le relevé du sous-utilisateur a été marqué comme OUVERT !",
            "successMarkedPaid": "Le relevé du sous-utilisateur a été marqué comme PAYÉ !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        },
        "modal": {
            "markAsPaid": {
                "header": "Marquer le relevé comme PAYÉ",
                "body": "Êtes-vous sûr de vouloir marquer le relevé {{statementName}} comme PAYÉ ?"
            },
            "markAsOpen": {
                "header": "Marquer le relevé comme OUVERT",
                "body": "Êtes-vous sûr de vouloir marquer le relevé {{statementName}} comme OUVERT ?"
            }
        }
    },
    "viewOnly": {
        "table": {
            "title": "Liste de vos relevés",
            "column": {
                "name": "Nom du relevé",
                "type": "Type",
                "quarter": "Trimestre",
                "year": "Année",
                "month": "Mois",
                "description": "Description",
                "amount": "Montant",
                "status": "Statut",
                "overview": "Aperçu",
                "details": "Détails"
            },
            "button": {
                "download": "Télécharger",
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "label": {
                "statusOpen": "Ouvert",
                "statusPaid": "Payé",
                "typeLicensing": "Licences",
                "typeRegular": "Régulier",
                "typeAudioMasteringServices": "Mastering Audio - Services",
                "typeVinylEarnings": "Revenus Vinyle",
                "typeOffset": "Compensation",
                "typeNotKnown": "Inconnu",
                "quarterQ1": "T1",
                "quarterQ2": "T2",
                "quarterQ3": "T3",
                "quarterQ4": "T4",
                "monthJanuary": "Janvier",
                "monthFebruary": "Février",
                "monthMarch": "Mars",
                "monthApril": "Avril",
                "monthMay": "Mai",
                "monthJune": "Juin",
                "monthJuly": "Juillet",
                "monthAugust": "Août",
                "monthSeptember": "Septembre",
                "monthOctober": "Octobre",
                "monthNovember": "Novembre",
                "monthDecember": "Décembre"
            },
            "message": {
                "statementUnavailable": "Tous les relevés émis avant janvier 2023 ont été envoyés par e-mail à votre gestionnaire de compte."
            }
        }
    }
};

export default subuserStatementsFR;